/* eslint-disable */
import React, { useRef, useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";

// translation --------------
import { useTranslation } from "react-i18next";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";

import { postData, getData, putData, uploadMultipleFile } from "utils/Gateway";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";

// import Select from "react-select";
import AfterSaveProjectModal from "components/Common/Modal/AfterSaveProjectModal";
import { projectDetailsHeaderLinks } from "helper/ProjectHelper/ProjectHelper";
import { createdAtToDateConverter } from "helper/Common/CommonHelper";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";

import { getAllCategories } from "helper/CategoryHelper/CategoryHelper";
import { ecosystemSlug } from "Config/Config";
import ProjectForm from "components/Common/ProjectForm/ProjectForm";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import ProjectDetilsView from "./ProjectDetailsView/ProjectDetilsView";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";

const ProjectDetailBody = () => {
  const params = useParams();
  const history = useHistory();

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const { t } = useTranslation(); //for translation

  const docFileInputRef = useRef(null); //for file input

  //*------ common header object ------*/
  const commonHeaderObject = projectDetailsHeaderLinks(params.id, t);

  //*------ bread crumb text ------*/
  const breadCrumbText = [
    { title: t("Projects"), link: "/admin/projectmanagement/list" },
    { title: t("Details") },
  ];

  const todayValue = new Date().toISOString().split("T")[0];

  const [isLoading, setisLoading] = useState(false);

  const [companyInput, setCompanyInput] = useState("");

  const [projectTypeList, setProjectTypeList] = useState([]);
  const [companyList, setCompanyList] = useState([]);

  // const [projectTypeValue, setProjectTypeValue] = useState(null);
  // const [projectTypeId, setprojectTypeId] = useState(null);
  // const [title, settitle] = useState("");
  // const [summary, setsummary] = useState("");
  // const [details, setdetails] = useState("");
  // const [startDate, setstartDate] = useState(todayValue);
  // const [endDate, setendDate] = useState(todayValue);
  // const [docFileUploading, setDocFileUploading] = useState(false);
  // const [uploadedDocFiles, setUploadedDocFiles] = useState([]);
  // const [uploadedDocFileIds, setUploadedDocFileIds] = useState([]);
  // const [isPublic, setIsPublic] = useState(false);

  const [projectData, setProjectField] = useState({
    projectType: null,
    company: null,
    title: "",
    summary: "",
    description: "",
    startDate: todayValue,
    endDate: todayValue,
    documents: [],
    documentIds: [],
    isPublic: false,
    isUploadingDocs: false,
    isSaving: false,
    error: "",
    validation: {
      projectType: false,
      title: false,
      startDate: false,
      endDate: false,
      endDateIsSmall: false,
    },
  });

  // const [isSaving, setIsSaving] = useState(false);
  const [savedProjectId, setsavedProjectId] = useState(null);

  const [isProjectModerator, setisProjectModerator] = useState(false);
  const [projectModeratorId, setprojectModeratorId] = useState(null);

  // const [projectMemberStatus, setProjectMemberStatus] = useState("1");
  // const [inviteDate, setinviteDate] = useState("");
  // const [loggedInMemberId, setLoggedInMemberId] = useState(null);

  const [memberStatus, setMemberStatus] = useState({});

  const [isAccepting, setisAccepting] = useState(false);

  //* alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get all category
  const fetchAllCategories = async () => {
    try {
      const parentSlug = "PROJECT_TYPE";
      const response = await getAllCategories(ecosystemSlug, parentSlug);

      setProjectTypeList(response);
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all company list
  const getCompanyList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_LIST +
        `?token=${token}&filtername=${companyInput}&modulefrom=backend`;

      console.log("url of company------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response in company------>", response);

      if (response.status) {
        setCompanyList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const documentUploadHandler = async (files) => {
    if (!files || files.length === 0) return;

    setProjectField((prev) => ({ ...prev, isUploadingDocs: true }));
    try {
      const uploadUrl = `${url.API_BASE_URL}${url.API_MULTIPLE_FILE_UPLOAD}?token=${token}`;
      const response = await uploadMultipleFile(uploadUrl, files);

      if (response.status) {
        const newFiles = response.data.map((file) => ({
          ...file,
          path: url.SERVER_URL + file.path,
        }));

        setProjectField((prev) => ({
          ...prev,
          documents: [...prev.documents, ...newFiles],
          documentIds: [
            ...prev.documentIds,
            ...response.data.map((f) => ({ _id: f._id })),
          ],
          isUploadingDocs: false,
        }));
      }
    } catch (error) {
      console.error("Document upload error:", error);
      setProjectField((prev) => ({ ...prev, isUploadingDocs: false }));
    }
  };

  //function for get project details
  const getProjectDetails = async () => {
    try {
      setisLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_PROJECT_FORM_DETAILS +
        `/${params.id}?token=${token}`;

      const response = await getData(requestUrl);

      console.log("response", response);

      if (response.status && response.data) {
        const data = response.data;

        setprojectModeratorId(data.moderator._id);
        let isModerator = false;

        if (
          data.moderator._id.toString() === userInfo._id.toString() ||
          userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN"
        ) {
          isModerator = true;
        } else {
          getMemberDetails();
        }

        setisProjectModerator(isModerator);

        setProjectField({
          projectType: data.projecttypevalue,
          company: data.companyvalue,
          title: data.title,
          summary: data.summary,
          description: data.description,
          startDate: data.startdate,
          endDate: data.enddate,
          documents:
            data.uploads?.map((file) => ({
              ...file,
              path: url.SERVER_URL + file.path,
            })) || [],
          documentIds: data.uploadedfileids || [],
          // isPublic: data?.ispublic ?? false,
          isUploadingDocs: false,
          isSaving: false,
          error: "",
          validation: {
            title: false,
            startDate: false,
            endDate: false,
            endDateIsSmall: false,
          },
        });
      } else {
        setAlertMessage(response.message);
        setMessageType("error");
        setShowAlert(true);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
    setisLoading(false);
  };

  //function for get details of event member
  const getMemberDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_PROJECT_MEMBER_DETAILS_QUERY +
        `?token=${token}&projectid=${params.id}`;

      const response = await getData(requestUrl);

      console.log("response in member details", response);

      if (response.status) {
        if (response.data) {
          // setLoggedInMemberId(response.data._id);
          // setProjectMemberStatus(response.data.memberstatus);
          // setinviteDate(createdAtToDateConverter(response.data.createdAt));
          setMemberStatus({
            id: response.data._id,
            status: response.data.memberstatus,
            modStatus: response.data.moderatorstatus,
            inviteDate: response.data.requestdate,
            joinDate: response.data.joiningdate,
            userid: response.data.user._id,
          });
        }
      } else {
        console.log(response.message);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //accept invite
  const acceptMemberInviteHandler = async () => {
    try {
      setisAccepting(true);
      const todayValue = new Date().toISOString().split("T")[0];
      let memberProjectData = {
        memberstatus: "1",
        project: params.id,
        joiningdate: todayValue,
        user: memberStatus.userid,
      };

      let requestUrl =
        url.API_BASE_URL +
        url.API_ACCEPT_INVITE_PROJECT_MEMBER +
        `/${memberStatus.id}` +
        `?token=${token}`;

      const response = await putData(requestUrl, memberProjectData);

      console.log("response in accept invite", response);

      setisAccepting(false);
      if (response.status) {
        getProjectDetails();
      } else {
        setAlertMessage(response.message);
        setMessageType("error");
        setShowAlert(true);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  // function for validate form
  const validateForm = () => {
    let isValid = true;

    if (projectData.projectType === null) {
      setProjectField((prev) => ({
        ...prev,
        validation: { ...prev.validation, projectType: true },
      }));
      isValid = false;
    }

    if (projectData.title === "") {
      setProjectField((prev) => ({
        ...prev,
        validation: { ...prev.validation, title: true },
      }));
      isValid = false;
    }

    if (projectData.startDate !== "" && projectData.endDate !== "") {
      if (projectData.startDate > projectData.endDate) {
        setProjectField((prev) => ({
          ...prev,
          validation: { ...prev.validation, endDateIsSmall: true },
        }));
        isValid = false;
      }
    }

    return isValid;
  };

  //function for save project
  const saveProjectHandler = async () => {
    if (!validateForm()) {
      setProjectField((prev) => ({
        ...prev,
        error: t("Please fill required fields"),
      }));
      window.scrollTo(0, 0);
      return;
    }

    try {
      setProjectField((prev) => ({ ...prev, isSaving: true }));

      let projectApiData = {
        projecttypeid: projectData.projectType.value,
        companyid: projectData.company?.value || null,
        title: projectData.title,
        summary: projectData.summary,
        description: projectData.description,
        startdate: projectData.startDate,
        enddate: projectData.endDate,
        uploads: projectData.documentIds,
      };

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (params.id) {
        requestUrl =
          requestUrl + url.API_UPDATE_PROJECT + `/${params.id}?token=${token}`;
        response = await putData(requestUrl, projectApiData);
      } else {
        requestUrl = requestUrl + url.API_ADD_NEW_PROJECT + `?token=${token}`;
        response = await postData(requestUrl, projectApiData);
      }

      console.log("response in save project---->", response);

      setProjectField((prev) => ({ ...prev, isSaving: false }));

      if (response.status) {
        setMessageType("success");
        setsavedProjectId(response.data._id);
        const bootstrapModal = new bootstrap.Modal(
          document.getElementById("afterSaveProjectModal")
        );
        bootstrapModal.show();
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  //function for reset
  const resetHandler = () => {
    setProjectField({
      projectType: null,
      company: null,
      title: "",
      summary: "",
      description: "",
      startDate: todayValue,
      endDate: todayValue,
      documents: [],
      documentIds: [],
      isPublic: false,
      isUploadingDocs: false,
      isSaving: false,
      error: "",
      validation: {
        projectType: false,
        title: false,
        startDate: false,
        endDate: false,
        endDateIsSmall: false,
      },
    });
  };

  //function for aftermodal close
  const afterSaveModalClose = (pageName) => {
    if (pageName == "details") {
      history.push(`/admin/projectmanagement/details/${savedProjectId}`);
    } else {
      resetHandler();
      history.push("/admin/projectmanagement/list");
    }
  };

  useEffect(() => {
    fetchAllCategories();
  }, []);

  useEffect(() => {
    if (companyInput.length > 1) {
      getCompanyList();
    }
  }, [companyInput]);

  useEffect(() => {
    if (params.id) {
      getProjectDetails();
    }
  }, [params.id]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  // Render condition
  if (
    !["ADMIN", "SUPER_ADMIN"].includes(userInfo.role?.slug) &&
    !moduleAccess.includes("MOD_PROJECT")
  ) {
    return <AccessDeniedView />;
  }

  return (
    <div id="content_wrapper">
      <section className="event-details-wrapper bg-white pb-5">
        {/* ------ common header -------- */}
        {params.id && (isProjectModerator || memberStatus.status === "1") && (
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("Details")}
          />
        )}

        <div className="container-fluid px-lg-5 pt-4 pt-md-0">
          {/* ------- bread crumb -------- */}
          <BreadCrumb
            breadCrumbText={breadCrumbText}
            bottom={true}
            displayName={`${projectData.title}`}
          />

          {/* -------- form area ---------- */}
          {isLoading ? (
            <LoadingSkeleton />
          ) : params.id && !isProjectModerator ? (
            <ProjectDetilsView
              projectData={projectData}
              memberStatus={memberStatus}
              acceptMemberInviteHandler={acceptMemberInviteHandler}
              isAccepting={isAccepting}
            />
          ) : (
            <ProjectForm
              projectData={projectData}
              setProjectField={(field) => (value) =>
                setProjectField((prev) => ({ ...prev, [field]: value }))}
              projectTypeList={projectTypeList}
              companyList={companyList}
              setCompanyInput={setCompanyInput}
              documentUploadHandler={documentUploadHandler}
              saveProjectHandler={saveProjectHandler}
              t={t}
              isEditMode={!!params.id}
              isSaving={projectData.isSaving}
            />
          )}
        </div>

        <AfterSaveProjectModal afterSaveModalClose={afterSaveModalClose} />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </section>
    </div>
  );
};

export default ProjectDetailBody;
